import { BaseQuestionResource } from "../types/BaseQuestionResource";
import { EdhConditionDisclosureResource } from "../types/EdhConditionDisclosureResource";
import { PayloadAction } from "@reduxjs/toolkit";
import { QuestionPageResource } from "../types/QuestionPageResource";
import { QuestionSectionResource } from "../types/QuestionSectionResource";

/**
 * Update disclosures attached to baseQuestion object.
 * @param pages Current pages in state.
 * @param action Action returned from the saga.
 * @return The updated pages slice with new base question merged.
 */
export const updateBaseQuestionDisclosures = (
  pages: QuestionPageResource[],
  action: PayloadAction<BaseQuestionResource>,
) => {
  return pages.map((page) => {
    return {
      ...page,
      sections: page.sections.map((section: QuestionSectionResource) => {
        return {
          ...section,
          baseQuestions: section.baseQuestions.map((baseQuestion) => {
            if (
              baseQuestion.code === action.payload.code &&
              action.payload._embedded
            ) {
              const disclosure = action.payload._embedded.disclosures
                ? action.payload._embedded.disclosures[0]
                : ({} as EdhConditionDisclosureResource);
              const { aliasName } = disclosure;
              const { disclosures } = baseQuestion;

              // Append aliasName of received disclosure to baseQuestion.
              const baseQuestionDisclosure = {
                ...disclosure,
                aliasName: aliasName,
              };

              // Find any existing disclosure of same name.
              // If found, merge into existing list. If not, create new.
              if (
                disclosures &&
                disclosures.find(
                  (disclosurePred: EdhConditionDisclosureResource) =>
                    disclosurePred.aliasName !== aliasName,
                )
              ) {
                baseQuestion.disclosures = [
                  ...disclosures,
                  baseQuestionDisclosure,
                ];
              } else {
                baseQuestion.disclosures = [baseQuestionDisclosure];
              }
              return baseQuestion;
            } else {
              return baseQuestion;
            }
          }),
        };
      }),
    };
  });
};
